export default __webpack_public_path__ + "static/media/github.50ecaab5.svg";